export const LABELS = {
  SELECT_DATE: 'Выберете дату',
  STATISTIC_DATE: 'Дата статистики',
  PLATFORM: 'PLATFORM',
  SELECT_PLATFORM: 'Выберете платформу',
  DATA_LOAD_ERROR: 'Ошибка загрузки данных',
  NO_FILTER_DATA: 'Нет данных для фильтра',
  TELEGRAM: 'Телеграм',
  INSTAGRAM: 'Инстаграм',
  EMPTY_CELL: '-',
  PAGE_NAME: 'Название страницы',
  DATE: 'Дата',
  NEW: 'Новых',
  RECEIVED: 'Принято',
  SENT_TO_MANAGERS: 'Менеджеру',
  SELECT_DATES_RANGE: 'Select Dates Range',
  DATE_PICKER_INPUT_PLACEHOLDER: 'Pick dates range',
  EXPERT_PAGE: 'EXPERT PAGE',
  TOTAL_INCOMING: 'TOTAL INCOMING',
  WITH_KEYWORD: 'KEYWORD TRIGGERS',
  WITH_DATE: 'DATE TRIGGERS',
  REPEATED: 'REPEATED KEYWORD TRIGGERS',
  AI_KEYWORD: 'AI KEYWORD REACTIONS',
  AI_DATE: 'AI DATE REACTIONS',
  UNDERAGE: 'UNDERAGE',
  WITHOUT_KEYWORD_AND_DATE: 'TRIGGERS WITHOUT KEYWORD & DATE',
  NO_FILTERS_SELECTION: 'Please, fill in filters data',

  NEW_SPREADS_BOT: 'Новые с датами бот',
  NEW_SPREADS_MANUAL: 'Новые с датами  ручная',
  NEW_KEYWORDS_BOT: 'Новые с кодовыми бот (пришло → расклад)',
  NEW_KEYWORDS_MANUAL: 'Новые с кодовыми ручная',
  NEW_SPREADS_TOTAL: 'Итого новых даты',
  NEW_KEYWORDS_TOTAL: 'Итого новых кодовые',
  NEW_TOTAL: 'Итого новых всего',

  REPEATING_SPREADS_MANUAL: 'Повторки с датами ручная',
  REPEATING_KEYWORDS_BOT: 'Повторки с кодовыми бот',
  REPEATING_KEYWORDS_MANUAL: 'Повторки с кодовыми ручная',
  REPEATING_SPREADS_TOTAL: 'Итого повторки даты',
  REPEATING_KEYWORDS_TOTAL: 'Итого повторки кодовые',
  REPEATING_TOTAL: 'Итого повторок всего',

  POST: 'POST',
  PUBLISHED: 'PUBLISHED',
  TOPIC: 'TOPIC',
  COST: 'COST',
  REACTIONS: 'REACTIONS',
  UNIQUE_REACTIONS: 'UNIQUE REACTIONS',
  NEW_DIALOGS: 'NEW DIALOGS',
  METRICS: 'METRICS',
  PAGE: 'PAGE',
  GEO: 'GEO',
  EXPERT: 'EXPERT',
};
